import React from 'react';
import type ServicedeskReportsCustomCreateType from '@atlassian/jira-spa-apps-servicedesk-reports-custom-create/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskReportsCustomCreate = lazyForPaint<
	typeof ServicedeskReportsCustomCreateType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-reports-custom-create", jiraSpaEntry: "async-servicedesk-reports-custom-create" */ '@atlassian/jira-spa-apps-servicedesk-reports-custom-create'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyServicedeskReportsCustomCreate}
		pageId="spa-apps/servicedesk/reports/custom/create"
		shouldShowSpinner
	/>
);
